<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage custom releases</small>
      </legend>
      <div></div>
      <div class="customreleasesLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i
          class="fa fa-spinner fa-spin"
          style="font-size: 24px; color: blue"
        >loading custom releases...</i>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemCustomreleases"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'Action'">
            <button class="btn btn-primary btn-sm btn-rounded" @click="viewCustomrelease(props.row.id)">
              <i class="fa fa-edit" data-toggle="tooltip" title="Edit custom releases!"></i> Edit customrelease
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by file code"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text"
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by bol"
          }
        },
        {
          label: "Wh7/T810 entry",
          field: "t810_entry",
          type: "text"
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadCustomreleases();
  },
  computed: {
    ...mapGetters(["systemCustomreleases"])
  },
  methods: {
    ...mapActions(["loadCustomreleases", "viewCustomrelease"])
  }
};
</script>


// WEBPACK FOOTER //
// src/customreleases/managecustomreleases.vue